import Component from '@glimmer/component';
import { action } from '@ember/object';
import ENV from 'donor-elf-web/config/environment';
import FundSummaryModel from 'donor-elf-web/models/fund-summary';
import moment from 'moment';

interface ComponentArgs {
  fundSummary: FundSummaryModel;
  showBalance: boolean;
  showAnnualGoal: boolean;
  onSortBy: (property: string) => void;
}

export default class FundSummaryRollingGoalComponent extends Component<ComponentArgs> {
  get rollingGoal() {
    return this.args.fundSummary.rollingGoal!;
  }

  @action
  viewLastYearTransactionReport() {
    window.location.href = `${ENV.rootURL}funds/${this.args.fundSummary.fundId}/transactions?incomeOrExpense=income&from=${moment().subtract(12, 'month').startOf('month').format('YYYY-MM-DD')}&to=${moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')}`;
  }

  @action
  viewPledgeReport() {
    window.location.href = `${ENV.rootURL}funds/${this.args.fundSummary.fundId}/pledges`;
  }
}
